import { GlobalSchemaFields, IDateRange } from '@/api/mongooseTypes';
import { RESTFUL } from '@/data/constants';
import { crudRead, crudUpdate, crudCreate } from '@/api/crud';
import { IProfile } from '@/api/auth/membership';

export class BrokerProfile extends GlobalSchemaFields {
  /** @type {string} **/
  role;
  /** @type {number} **/
  displayName;
  /** @type {string} */
  brokerServer;

  constructor(obj) {
    super(obj);
  }
}

/**
 * @param {AxiosInstance} api
 * @param {string} id
 */
export async function readBrokerProfile(api, id) {
  return await crudRead(api, RESTFUL.brokerProfile.read, id);
}

/**
 * @param {AxiosInstance} api
 * @param {Partial<BrokerProfile>} brokerProfileFields
 */
export async function createBrokerProfile(api, brokerProfileFields) {
  return await crudCreate(api, RESTFUL.brokerProfile.create, brokerProfileFields);
}

/**
 * @param {AxiosInstance} api
 * @param {string} id
 * @param {Partial<BrokerProfile>} brokerProfileFields
 */
export async function updateBrokerProfile(api, id, brokerProfileFields) {
  return await crudUpdate(api, RESTFUL.brokerProfile.update, id, brokerProfileFields);
}

/**
 * @param {AxiosInstance} api
 * @param {Partial<IProfile & IUser>} profileAndUserFields
 */
export async function createUserWithProfile(api, profileAndUserFields) {
  return await crudCreate(api, RESTFUL.user.create, profileAndUserFields);
}

/**
 * @param {AxiosInstance} api
 * @param {string} id
 * @param {Partial<IProfile>} profileFields
 */
export async function updateProfile(api, id, profileFields) {
  return await crudUpdate(api, RESTFUL.profile.update, id, profileFields);
}

/**
 * @param {AxiosInstance} api
 * @param {string} id
 * @param {{populate?: *}} [options]
 */
export async function readPlatformTradeHistory(api, id, options) {
  return await crudRead(api, RESTFUL.platformTradeHistory.read, id, options);
}

/**
 * @param {AxiosInstance} api
 * @param {string} id
 */
export async function enableProfile(api, id, enabled) {
  return await api.post('bn/admin/profile/enableProfile', {
    enabled,
    profileId: id,
  });
}
